//@ts-nocheck
import React, { memo, useEffect } from 'react';
import DayDatePicker from './datepickerDays/DatepickerDays';
import PassedDates from './passedDates/PassedDates';
import useDatePicker from '../hooks/useDatepicker';
const SimpleDayPicker = ({
  pickerDate,
  onDayClick,
  onDayHover,
  checkOutDate,
  checkInDate,
  todayDate,
  hoveredDate,
  nextRangeDays,
  isFull = false,
  onlyDays = false,
  index = 0,
  withTooltip
}) => {
  const {
    dayRefs,
    hoverRef,
    leaveRef,
    isDayDisabled,
    getClassNames,
    handleDayClick,
    getDatePickerTooltipData,
    formatPrice,
    getStateAndClassNames
  } = useDatePicker({
    checkInDate,
    checkOutDate,
    hoveredDate,
    onDayClick,
    onDayHover,
    todayDate,
    nextRangeDays,
    pickerDate,
    index,
    onlyDays,
    withTooltip
  });
  return <>
      <PassedDates numberOfRows={pickerDate.firstDayOfMonthWeekDay} data-sentry-element="PassedDates" data-sentry-source-file="DayDatePickerWrapper.tsx" />
      {pickerDate.days.map(item => <DayDatePicker key={item.ts} ref={el => dayRefs.current[item.ts] = el} item={item} classNameList={getStateAndClassNames(item).classNames} showTooltip={Boolean(item.is_non_bookable || item.min_book_day > 1)} tooltipContent={getDatePickerTooltipData(item)} todayDate={todayDate} nextRangeDays={nextRangeDays} formatPrice={formatPrice} isDayDisabled={isDayDisabled(item)} isFull={isFull} onDayClick={handleDayClick} leaveRef={leaveRef} hoverRef={hoverRef} />)}
    </>;
};
export default memo(SimpleDayPicker);